export const ERROR_FRAGMENT = `
  message
  field
  code
`;

export const PALLET_TYPE_FRAGMENT = `
  id
  name
  description
  isActive
  sortOrder
`;

export const UNIT_TYPE_FRAGMENT = `
  id
  name
  description
  isActive
  sortOrder
`;

export const SQUARE_FOOTAGE_TYPE_FRAGMENT = `
  id
  name
  description
  isActive
  sortOrder
`;

export const SCHEDULER_FRAGMENT = `
  id
  name
  frequency
  active
  nextRunAt
  lastRunAt
  daysOfWeek
  dayOfMonth
  dateRangeMode
  notes
  reportsSchedulers {
    id
  project {
    id
    name
    settings
  }
    favoriteReport {
      id
      payload
    }
    options
  }
`;

export const ADDRESS_FRAGMENT = `
  street
  street2
  zipCode
  city
  state
  vmJobNumber
  vmRoNumber
  addressName
`;

export const ASSET_IMAGE_FRAGMENT = `
  url
  id
  default
  assetId
  createdAt
`;

export const WAREHOUSE_LOCATION_IMAGE_FRAGMENT = `
  url
  id
  default
`;

export const KIT_IMAGE_FRAGMENT = `
  url
  id
  default
  assetId
`;

export const COST_CENTER_FRAGMENT = `
  id
  active
  disabled
  costCenterName
  costCenterCode
  comments
  billingRates
  laborRates
  materialRates
  openInspectRates
  equipmentRates
  billingTypes
  useProjectBillingConfiguration
  minimumAssetImages
  generalNotificationsEmailSendList
  osdEmailSendList
  approvedEmailSendList
  outboundOnlyEmailSendList
  automatedReportsEmailSendList
`;

export const SIMPLE_COST_CENTER_FRAGMENT = `
  id
  active
  disabled
  costCenterName
  costCenterCode
  comments
  minimumAssetImages
`;

export const USER_FRAGMENT = `
  id
  email
  name
  phoneNumber
  uid
  token
  invitationAccepted
  role
  clientIds
  projectIds
  costCenterIds
  captureTableSettings
  assetsTableSettings
  trackingTableSettings
  manageTableSettings
  kitsTableSettings
  warehouseTableSettings
  selectionContext
  settings
  permissions
  canAccessShoppingInternalWorkOrders
  canEditOrders
  hasSuperAdminControls
  mainLogoUrl
  customerLogoUrl
  lastSeenReleaseId
  intercomMessenger {
    appId
    jwt
  }
  company {
    id
    name
    subdomain
    isAdministrate
    settings
    permissions
    settingsConfig
    labelsLogoUrl
    secondaryLogoUrl
    subsidiaryLogoUrl
    subsidiary2LogoUrl
    blackoutDates
    fieldSettings
    receivingSettings
    projectTypeFieldSettings
    billingRates
    laborRates
    materialRates
    openInspectRates
    equipmentRates
    shipmentPdfFields
    shipmentItemPdfFields
    inventoryRequestPdf
    shipmentItemMoveLabelPdfFields
    availableProjectTypes
    enabledBillingTypes
    enabledIntegrationProviders
    internalWorkOrderTypes
    palletTypes {
      id
      name
      description
      isActive
      sortOrder
    }
    unitTypes {
      id
      name
      description
      isActive
      sortOrder
    }
    squareFootageTypes {
      ${SQUARE_FOOTAGE_TYPE_FRAGMENT}
    }
  }
  workspaces {
    id
    name
    subdomain
    vendorName
    labelsLogoUrl
    isAdministrate
  }
  accessLink {
    id
  }
`;

export const PAGINATION_FRAGMENT = `
  totalPages
  totalCount
  currentPage
  limitValue
`;

export const ATTACHMENT_FRAGMENT = `
  id
  url
  pairId
  fileExtension
  fileSize
  fileName
  createdAt
`;

export const KIT_FRAGMENT = `
  id
  assetId
  itemId
  photo
  manufacturer
  description
  descriptionComments
  dimensions
  color
  model
  groupBySkuNumber
  images {
    ${KIT_IMAGE_FRAGMENT}
  }
  project {
    id
    name
    settings
  }
  client {
    id
    name
  }
`;

export const GROUPED_ASSET_FRAGMENT = `
  id
  assetId
  itemId
  photo
  manufacturer
  description
  descriptionComments
  skuNumber
  serializedGroupedAsset
  availableQuantity
  requiredCompanionLinks {
    id
    quantity
    companionGroupedAsset {
      id
      itemId
      assetId
      description
      skuNumber
      availableQuantity
      serializedGroupedAsset
    }
  }
  groupedAssetMembers {
    id
    quantity
    asset {
      id
      itemId
      skuNumber
      description
    }
  }
  images {
    ${ASSET_IMAGE_FRAGMENT}
  }
  project {
    id
    name
    settings
  }
  client {
    id
    name
  }
`;

export const KIT_ASSET_FRAGMENT = `
  id
  kitAssets {
    id
    quantity
    asset {
      id
      assetId
      photo
      images {
        ${ASSET_IMAGE_FRAGMENT}
      }
      model
      description
      dimensions
      quantity
    }
  }
`;

export const CUSTOM_FIELD_TEMPLATE_FRAGMENT = `
  id
  defaultLabel
  defaultValue
  fieldType
  availableOptions
  autoAddCustomValues
  restrictToAvailableOptions
  enableBarcodeScanner
  multipleValues
  project {
    id
  }
`;

export const CUSTOM_FIELD_FRAGMENT = `
  id
  label
  value
  customFieldTemplate {
    ${CUSTOM_FIELD_TEMPLATE_FRAGMENT}
  }
`;

export const ASSET_FRAGMENT = `
  id
  type
  itemId
  assetId
  projectId
  barcode
  updatedAt
  lockVersion
  changedFields
  storageCharges
  taxCharges
  billingCharges
  palletType
  unitType
  squareFootageType
  weight
  squareFootage
  cubicFootage
  dimensions
  availableQuantity
  warehouseQuantity
  inCartQuantity
  reservedQuantity
  allocatedQuantity
  rackLocations
  quantity
  category
  costCenter {
    ${SIMPLE_COST_CENTER_FRAGMENT}
  }
  warehousesFromRackLocations {
    id
    warehouseId
    name
    excludeFromBilling
  }
  description
  descriptionComments
  quantity
  color
  manufacturer
  condition
  minimumQuantity
  finishes
  existingBuilding
  newBuilding
  existingFloor
  newFloor
  existingRoom
  newRoom
  employeeName
  originComments
  destinationComments
  originEmployeeName
  destinationEmployeeName
  destinationQuantity
  originRoomNumber
  destinationRoomNumber
  destinationRoomNumbers
  disposition
  originCubbyNumber
  notes
  photo
  quantityOrdered
  quantityReceived
  model
  poNumber
  itemCode
  unitCost
  subcategory
  daysLeftToExpire
  images {
    ${ASSET_IMAGE_FRAGMENT}
  }
  project {
    id
    name
    settings
    fieldSettings
    shipmentItemPdfPreferences
    storeCardFields
    billingTypes
    palletTypes {
      ${PALLET_TYPE_FRAGMENT}
    }
    unitTypes {
      ${UNIT_TYPE_FRAGMENT}
    }
    squareFootageTypes {
      ${SQUARE_FOOTAGE_TYPE_FRAGMENT}
    }
  }
  client {
    id
    name
  }
  attachments {
    ${ATTACHMENT_FRAGMENT}
  }
  receivingReportNumber
  osdNotes
  generalNotes
  inventoryNumber
  skuNumber
  manufacturePartNumber
  batchNumber
  billingType
  expirationDate
  expirationMonthDayYear
  manufactureDate
  expirationMonth
  expirationYear
  assetTotalWeight
  unitOfMeasure
  importedCustomAttributes
  predefinedCubicFeet
  hasVariants
  serialNumber
  carrierName
  orderNumber
  bolNumber
  trackingNumber
  truckNumber
  shipmentItems {
    id
    quantity
    shipment {
      id
      shipmentId
    }
  }
  customFields {
    ${CUSTOM_FIELD_FRAGMENT}
  }
  createdAt
  updatedAt
  lastIn
  lastOut
  groupBySkuNumber
  serializedGroupedAsset
  requiredCompanionLinks {
    id
    quantity
    companionGroupedAsset {
      id
      itemId
      assetId
      description
      skuNumber
      availableQuantity
      serializedGroupedAsset
    }
  }
`;

export const SIMPLE_ASSET_FRAGMENT = `
  id
  type
  itemId
  assetId
  availableQuantity
  description
  descriptionComments
  color
  dimensions
  manufacturer
  photo
  model
  itemCode
  skuNumber
  images {
    ${ASSET_IMAGE_FRAGMENT}
  }
  serialNumber
  rackLocations
  client {
    id
    name
  }
  project {
    id
    name
    settings
    fieldSettings
    selectedMainLogoUrl
    customerLogoUrl
  }
`;

export const ASSET_MEDICAL_FRAGMENT = `
  departmentName
  serialNumberUrl
  serialNumber
  model
  destinationNumber
  installResponsibility
`;

export const CLIENT_BASIC_FRAGMENT = `
  id
  name
  disabled
`;

export const PROJECT_FRAGMENT = `
  id
  name
  active
  disabled
  storageEnabled
  projectType
  billing
  billingMethod
  billingDate
  billingAnchorDate
  billingValidationStatus
  billingTypes
  billingRates
  billingNotes
  laborRates
  materialRates
  openInspectRates
  equipmentRates
  fieldSettings
  receivingSettings
  receivingWizardBillingStep
  addPreviouslyReceivedAssetsToShipments
  shipmentPdfFields
  shipmentItemPdfFields
  inventoryRequestPdf
  shipmentItemMoveLabelPdfFields
  storeCardFields
  clientId
  createdAt
  createdBy {
    id
    email
  }
  settings
  importedAssets
  customerName
  customerOwner
  customerNotes
  escalationEmailSendList
  contactName
  contactEmail
  contactPhoneNumber
  customerEmailSendList
  osDEmailSendList
  billingEmailSendList
  outboundOnlyEmailSendList
  deliveryOnlyEmailSendList
  approvedEmailSendList
  automatedReportsEmailSendList
  mainLogoSelection
  selectedMainLogoUrl
  partnerLogoUrl
  customerLogoUrl
  referenceAssets
  orderNumber
  customerPoNumber
  shipmentItemUnitBreakdown
  kitting
  groupedAssets
  groupedSerializedAssets
  shipmentItemPdfPreferences
  addresses {
    ${ADDRESS_FRAGMENT}
  }
  costCenters {
    ${COST_CENTER_FRAGMENT}
  }
  client {
    ${CLIENT_BASIC_FRAGMENT}
  }
  warehouses {
    id
    name
    warehouseId
  }
  allowExternalUsersToCreateInternalOrders
  allowExternalUsersToEditOrders
  minimumAssetImages
  minimumShipmentImages
  images {
    ${ATTACHMENT_FRAGMENT}
  }
  taxableChargeTypes
  resolvedTaxableChargeTypes
  storageCalculationMethod
  resolvedStorageCalculationMethod
  monthlyValuationFee
  billingQuantityCalculationMode
  billingRules
  colocationBillingEnabled
  useMinimumChargeForStorage
  palletTypes {
    id
    name
    description
    isActive
    sortOrder
  }
  unitTypes {
    id
    name
    description
    isActive
    sortOrder
  }
  squareFootageTypes {
    ${SQUARE_FOOTAGE_TYPE_FRAGMENT}
  }
`;

export const SIMPLE_PROJECT_FRAGMENT = `
  id
  name
  disabled
  active
  clientId
`;

export const CLIENT_FRAGMENT = `
  id
  name
  branchCode
  disabled
  settings
  clientEmailSendList
  clientBillingEmailSendList
  clientOsdEmailSendList
  shipmentItemPdfPreferences
  mainLogoSelection
  selectedMainLogoUrl
  taxableChargeTypes
  resolvedTaxableChargeTypes
  storageCalculationMethod
  resolvedStorageCalculationMethod
  company {
    id
    labelsLogoUrl
    subsidiaryLogoUrl
    subsidiary2LogoUrl
  }
  projects {
    ${PROJECT_FRAGMENT}
  }
`;

export const BARCODE_SCAN_FRAGMENT = `
  id
  projectId
  clientId
  assetId
  barcode
  location
  address
  position
  employeeName
  scanDate
`;

export const FAVORITE_REPORTS_FRAGMENT = `
  id
  projectId
  payload
  createdAt
  reportNotes
  project {
    name
  }
  user {
    email
  }
  notifications {
    client { id }
    project { id }
  }
  favoriteReportsProjects{
    project{
      id
    }
  }
`;

export const BILLING_PERIOD_FRAGMENT = `
  id
  label
  startDate
  endDate
  year
  month
  hasReport
  createdAt
  billingReport {
    id
    periodStart
    periodEnd
    version
    reportUrl
    notified
    notifiedAt
    notifiedByUser {
      id
      email
      name
    }
    chargeSummary
    billingCharges
    canSendReplacementInvoice
    canGenerateInvoiceExport
    invoice {
      id
      number
      status
      replacement
      exports {
        id
        provider
        status
        filename
        deliveredAt
      }
    }
    fingerprint
    createdAt
    updatedAt
  }
  billingReports {
    id
    periodStart
    periodEnd
    version
    reportUrl
    notified
    notifiedAt
    notifiedByUser {
      id
      email
      name
    }
    chargeSummary
    billingCharges
    canSendReplacementInvoice
    canGenerateInvoiceExport
    invoice {
      id
      number
      status
      replacement
      exports {
        id
        provider
        status
        filename
        deliveredAt
      }
    }
    fingerprint
    createdAt
    updatedAt
    user {
      id
      email
      name
    }
    favoriteReport {
      id
      payload
    }
  }
`;

export const MOVE_MATRIX_FRAGMENT = `
  id
  status
  processingLog
  createdAt
  originalFile {
    filename
    downloadUrl
  }
  processedFile {
    filename
    downloadUrl
  }
`;

export const SHOPPING_INVENTORY_ITEM_FRAGMENT = `
  id
  assetId
  quantity
  deliveryDate
  deliveryTime
  building
  floor
  room
  location
  city
  street
  zip
  poNumber
  idsrNumber
  eocNumber
  comment
  status
  position
  pickedStatus
  stagedStatus
  placeholderForGroupedAsset
  parentInventoryItemId
  requiredCompanion
  disposition
  project {
    id
    name
    settings
    selectedMainLogoUrl
    customerLogoUrl
  }
`;

export const SHOPPING_INVENTORY_REQUEST_FRAGMENT = `
  assets {
    ${ASSET_FRAGMENT}
  }
  status
  email
  inventoryItems {
    ${SHOPPING_INVENTORY_ITEM_FRAGMENT}
  }
`;

export const SIMPLE_SHOPPING_INVENTORY_REQUEST_FRAGMENT = `
  id
  projectName
  projectId
  shoppingCartKind
  shoppingCartProjectId
  assets {
    ${SIMPLE_ASSET_FRAGMENT}
  }
  status
  email
  inventoryItems {
    ${SHOPPING_INVENTORY_ITEM_FRAGMENT}
  }
`;

export const ACCESS_LINK_FRAGMENT = `
  id
  name
  token
  active
  projectIds
  permissions
  createdAt
  createdBy {
    id
    name
    email
  }
`;

export const INVENTORY_ITEM_FRAGMENT = `
  id
  pickedStatus
  stagedStatus
  placeholderForGroupedAsset
  parentInventoryItemId
  requiredCompanion
  inventoryRequestId
  assetId
  quantity
  rackLocations
  checkedOutQuantity
  checkedInQuantity
  status
  addressLine
  comment
  deliveryDate
  deliveryTime
  building
  floor
  room
  location
  city
  street
  zip
  poNumber
  idsrNumber
  eocNumber
  createdAt
  updatedAt
  location
  disposition
  position
  project {
    id
    name
    settings
  }
   asset {
     ${ASSET_FRAGMENT}
   }
`;

export const DETAILED_INVENTORY_REQUEST_FRAGMENT = `
  id
  uid
  status
  email
  ccEmails
  reviewStatus
  createdAt
  requestedAt
  autoApproved
  addressLine
  multipleAddress
  workOrderNumber
  outboundWeight
  manualOutboundWeight
  effectiveOutboundWeight
  outboundWeightOverridden
  poNumber
  requirements
  designer
  startDate
  startTime
  endDate
  endTime
  comment
  configurableField1
  configurableField2
  configurableField3
  configurableField4
  configurableField5
  resources
  street
  city
  zipCode
  members
  vaStatus
  vaStatusDetailed
  revisionNumber
  contactName
  contactPhoneNumber
  location
  deliveryDate
  disposition
  pickingNotes
  projectName
  projectId
  billingQuantities
  billingQuantityInputMetadata
  pickingStartTime
  pickingCompleteTime
  finalReleaseNotes
  trackingDetails
  warehousesFromInventoryItems {
    id
    warehouseId
    name
    excludeFromBilling
  }
  user {
    id
    email
  }
  locationNotes
  inventoryItems {
    ${INVENTORY_ITEM_FRAGMENT}
  }
  outboundCharges
  materialCharges
  laborCharges
  equipmentCharges
  oneTimeCharges
  billingCharges
  salesTax
`;

export const SIMPLE_INVENTORY_REQUEST_FRAGMENT = `
  id
  uid
  email
  createdAt
  requestedAt
  workOrderNumber
  outboundWeight
  manualOutboundWeight
  effectiveOutboundWeight
  outboundWeightOverridden
  comment
  finalReleaseNotes
  trackingDetails
  configurableField1
  configurableField2
  configurableField3
  resources
  designer
  startDate
  startTime
  endDate
  endTime
  deliveryDate
  vaStatus
  revisionNumber
  projectName
  projectId
  billingQuantities
  billingQuantityInputMetadata
  warehousesFromInventoryItems {
    id
    warehouseId
    name
    excludeFromBilling
  }
  inventoryItems {
    project {
      id
      settings
    }
  }
  user {
    id
    email
  }
  outboundCharges
  materialCharges
  laborCharges
  equipmentCharges
  oneTimeCharges
  billingCharges
  salesTax
  externalRecords {
    id
    recordType
    externalId
    data
  }
`;

export const SIMPLE_CALENDAR_INVENTORY_REQUEST_FRAGMENT = `
  id
  uid
  email
  createdAt
  requestedAt
  workOrderNumber
  comment
  resources
  designer
  startDate
  startTime
  endDate
  endTime
  deliveryDate
  vaStatus
  revisionNumber
  user {
    id
    email
  }
`;

export const CALENDAR_INVENTORY_REQUEST_WITH_PROJECT_NAME_FRAGMENT = `
  id
  workOrderNumber
  vaStatus
  vaStatusDetailed
  projectName
`;

export const OPTIMIZED_INVENTORY_REQUEST_FRAGMENT = `
  id
  uid
  status
  email
  ccEmails
  reviewStatus
  createdAt
  requestedAt
  autoApproved
  addressLine
  multipleAddress
  workOrderNumber
  outboundWeight
  manualOutboundWeight
  effectiveOutboundWeight
  outboundWeightOverridden
  poNumber
  requirements
  designer
  reservedForUserId
  reservedForUser {
    id
    name
    email
  }
  startDate
  startTime
  endDate
  endTime
  comment
  configurableField1
  configurableField2
  configurableField3
  configurableField4
  configurableField5
  resources
  street
  city
  zipCode
  members
  vaStatus
  vaStatusDetailed
  revisionNumber
  contactName
  contactPhoneNumber
  location
  deliveryDate
  disposition
  pickingNotes
  projectName
  projectId
  billingQuantities
  billingQuantityInputMetadata
  pickingStartTime
  pickingCompleteTime
  finalReleaseNotes
  trackingDetails
  warehousesFromInventoryItems {
    id
    warehouseId
    name
    excludeFromBilling
  }
  user {
    id
    email
    accessLink {
      id
      name
    }
  }
  requestor {
    id
    name
    email
  }
  locationNotes
  billingValidationStatus
  outboundCharges
  materialCharges
  laborCharges
  equipmentCharges
  oneTimeCharges 
  billingCharges
  salesTax
  inventoryItems {
    id
    pickedStatus
    stagedStatus
    placeholderForGroupedAsset
    inventoryRequestId
    assetId
    quantity
    rackLocations
    checkedOutQuantity
    checkedInQuantity
    status
    addressLine
    comment
    deliveryDate
    deliveryTime
    building
    floor
    room
    location
    city
    street
    zip
    poNumber
    idsrNumber
    eocNumber
    createdAt
    updatedAt
    location
    disposition
    position
  project {
    id
    name
    settings
  }
    asset {
      id
      type
      itemId
      assetId
      barcode
      inventoryNumber
      skuNumber
      batchNumber
      itemCode
      serialNumber
      weight
      photo
      availableQuantity
      reservedQuantity
      rackLocations
      quantity
      description
      descriptionComments
      manufacturer
      model
      dimensions
      color
      condition
      billingType
      groupBySkuNumber
  project {
    id
    name
    settings
  }
      images {
        url
        id
        default
        assetId
        createdAt
      }
    }
    kitInventoryItems {
      id
      quantity
      asset {
        id
        itemId
        description
  project {
    id
    name
    settings
  }
        images {
          url
          id
          default
          assetId
          createdAt
        }
      }
    }
  }
`;

export const LOCATION_FRAGMENT = `
  id
  name
  address
  favoriteLocation
  priority
`;

export const REQUESTOR_FRAGMENT = `
  id
  name
  email
`;

export const WAREHOUSE_LOCATION = `
  id
  locationId
  locationName
  searchTerms
  slotGroupKey
  zone
  locationType
  aisle
  rack
  shelf
  slot
  sqFtOfSlot
  occupied
  dimensions
`;

export const WAREHOUSE_LOCATION_WITH_IMAGES = `
  id
  locationId
  locationName
  searchTerms
  slotGroupKey
  zone
  locationType
  aisle
  rack
  shelf
  slot
  sqFtOfSlot
  dimensions
  active
  warehouseLocationImages {
    ${WAREHOUSE_LOCATION_IMAGE_FRAGMENT}
  }
  occupied
  createdBy {
    id
    email
  }
  warehouse {
    id
    warehouseId
    name
  }
`;

export const MOBILE_WAREHOUSE_LOCATION_WITH_IMAGES = `
  id
  locationId
  locationName
  searchTerms
  zone
  locationType
  sqFtOfSlot
  dimensions
  active
  mobileLocationImage {
    ${WAREHOUSE_LOCATION_IMAGE_FRAGMENT}
  }
  occupied
  createdBy {
    id
    email
  }
`;

export const SIMPLE_CALENDAR_SHIPMENT_FRAGMENT = `
  id
  shipmentId
  bol
  carrierName
  shipmentStatus
  orderNumber
  receivedAt
  totalPieces
  vendorName
  user {
    email
    name
  }
  project {
    id
    name
  }
`;

export const SHIPMENT_APPROVAL_TABLE_FRAGMENT = `
  id
  shipmentId
  revisionNumber
  receivedAt
  hasOsd
  completer {
    email
  }
  project {
    id
    name
  }
`;

export const SHIPMENT_FRAGMENT = `
  id
  shipmentId
  bol
  revisionNumber
  carrierName
  draft
  shipmentStatus
  notes
  orderNumber
  totalPieces
  billingQuantities
  billingQuantityInputMetadata
  notifiedAt
  requiresNotification
  customerPoNumber
  weightUnits
  totalWeight
  calculatedTotalWeight
  vendorName
  trackingNumber
  truckNumber
  billingType
  createdAt
  updatedAt
  startTime
  completeTime
  receivedAt
  costCenter {
    id
    costCenterName
    approvedEmailSendList
  }
  user {
    email
    name
  }
  completer {
    email
    name
  }
  project {
    id
    name
    billing
    billingTypes
    billingQuantityCalculationMode
    minimumShipmentImages
    shipmentItemPdfPreferences
    costCenters {
      ${SIMPLE_COST_CENTER_FRAGMENT}
    }
    materialRates
    laborRates
    openInspectRates
    equipmentRates
    settings
    approvedEmailSendList
  }
  attachments {
    ${ATTACHMENT_FRAGMENT}
  }
  warehousesFromRackLocations {
    id
    warehouseId
    name
    excludeFromBilling
  }
  inboundCharges
  oneTimeCharges
  materialCharges
  laborCharges
  openInspectCharges
  equipmentCharges
  salesTax
  billingCharges
  shipmentItems {
    id
    rackLocations
  }
  externalRecords {
    id
    recordType
    externalId
    data
  }
`;

export const SHIPMENT_ITEM_FRAGMENT = `
  id
  shipmentId
  assetId
  quantity
  weight
  rackLocations
  dimensions
  expectedQuantity
  palletsReceivedCount
  itemNotes
  totalPieces
  asset {
    id
    itemId
    assetId
    itemCode
    barcode
    skuNumber
    description
    serialNumber
    availableQuantity
    rackLocations
    palletType
    unitType
    quantity
    weight
    images {
      ${ASSET_IMAGE_FRAGMENT}
    }
    customFields {
      id
      label
      value
    }
  }
  attachments {
    ${ATTACHMENT_FRAGMENT}
  }
`;

export const OPTIMIZED_INTERNAL_WORK_ORDER_FRAGMENT = `
  id
  uid
  internalWorkOrderNumber
  revisionNumber
  vaStatus
  internalWorkOrderType
  destinationWarehouse {
    id
    warehouseId
    name
  }
  costCenter {
    ${SIMPLE_COST_CENTER_FRAGMENT}
  }
  comment
  deadlineDate
  contactName
  contactPhoneNumber
  pickingStartTime
  pickingCompleteTime
  createdAt
  updatedAt
  user {
    id
    email
  }
  project {
    id
    name
    settings
  }
  warehouse {
    id
    warehouseId
    name
  }
  warehousesFromInternalItems {
    id
    warehouseId
    name
    excludeFromBilling
  }
  billingType
  billingQuantities
  internalWorkOrderCharges
  materialCharges
  laborCharges
  equipmentCharges
  oneTimeCharges
  billingCharges
  salesTax
  internalWorkOrderItems {
    id
    quantity
    nonAllocating
    comment
    createdAt
    rackLocations
    pickedStatus
    completedStatus
    asset {
      id
      assetId
      itemId
      model
      description
      barcode
      condition
      manufacturer
      model
      color
      dimensions
      skuNumber
      availableQuantity
      rackLocations
      costCenter {
        ${SIMPLE_COST_CENTER_FRAGMENT}
      }
  project {
    id
    name
    settings
  }
      images {
        url
        id
        default
      }
    }
    requestedBy {
      id
      name
      email
    }
    attachments {
      ${ATTACHMENT_FRAGMENT}
    }
  }
  warehousesFromInternalItems {
    id
    warehouseId
    name
    excludeFromBilling
  }
`;

export const DELIVERY_ITEM_FRAGMENT = `
  id
  assetId
  deliveryId
  quantity
  status
  createdAt
  updatedAt
  addressLine
  comment
  poNumber
  position
  building
  floor
  room
  location
  street
  city
  zip
  pickedStatus
  verifiedDeliveredQuantity
  rackLocations
  asset {
    id
    type
    itemId
    assetId
    barcode
    photo
    description
    descriptionComments
    manufacturer
    model
    dimensions
    color
    condition
    skuNumber
    availableQuantity
    rackLocations
    quantity
    images {
      ${ASSET_IMAGE_FRAGMENT}
    }
    project {
      id
      name
      settings
    }
  }
  project {
    id
    name
    settings
  }
  attachments {
    ${ATTACHMENT_FRAGMENT}
  }
`;

export const DELIVERY_FRAGMENT = `
  id
  uid
  inventoryRequestId
  deliveryUserId
  receiverUserId
  createdAt
  requestedAt
  deliveredAt
  vaStatus
  addressLine
  comment
  deliveryNotes
  email
  contactName
  contactPhoneNumber
  workOrderNumber
  poNumber
  location
  deliveryDate
  locationNotes
  pickedStatus
  signatureImageUrl
  signedByName
  signedAt
  hasSignedDocument
  street
  city
  zip
  projectId
  projectName
  deliveryUser {
    id
    email
    name
  }
  receiverUser {
    id
    email
    name
  }
  deliveryItems {
    ${DELIVERY_ITEM_FRAGMENT}
  }
  attachments {
    ${ATTACHMENT_FRAGMENT}
  }
`;

export const SIMPLE_DELIVERY_FRAGMENT = `
  id
  uid
  inventoryRequestId
  deliveryUserId
  createdAt
  deliveredAt
  vaStatus
  addressLine
  comment
  contactName
  workOrderNumber
  deliveryDate
  projectId
  projectName
  pickedStatus
  hasSignedDocument
  hasAttachments
  attachmentCount
  deliveryItemsCount
  deliveryUser {
    id
    email
    name
  }
`;

